import React, { Component } from "react";
import "../css/ProductDetail.css";
import products from "../json/products.json";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import order1 from "../images/order1.png";
import order2 from "../images/order2.png";
import order3 from "../images/order3.png";
import { Link } from "react-router-dom";
import { Lines } from "react-preloaders";
import productImages from "../images";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3,
  },
};

export default class ProductDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: [],
      products: [],
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick(e, product) {
    this.setState({
      product: product,
    });
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const id = params.get("id");
    this.setState({
      product: products.find((v) => (v.id = id)),
      products: products,
    });
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <div className="productDetail container">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-12">
              {this.state.product.id !== undefined ? (
                <img src={productImages[this.state.product.id]} className="img-fluid shadow rounded" alt="" />
              ) : (
                <></>
              )}
            </div>
            <div className="col-lg-8 col-md-8 col-11 card mx-auto">
              <h1 className="title">Product</h1>
              <div className="row">
                <div className="col-lg-8">
                  <table className="table table-responsive table-borderless table-hover">
                    <tbody>
                      <tr>
                        <td>Categories</td>
                        <td>:</td>
                        <td>{this.state.product.title}</td>
                      </tr>
                      <tr>
                        <td>Name</td>
                        <td>:</td>
                        <td>{this.state.product.category}</td>
                      </tr>
                      <tr>
                        <td>Price</td>
                        <td>:</td>
                        <td>{this.state.product.price}</td>
                      </tr>
                      <tr>
                        <td>is Available</td>
                        <td>:</td>
                        <td>{this.state.product.availability === "1" ? "Yes" : "No"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-lg-4">
                  <h5>Buy Here !</h5>
                  <hr />
                  {this.state.product.link_bukalapak === null ? (
                    ""
                  ) : (
                    <a href={this.state.product.link_bukalapak}>
                      <img src={order1} className="img-fluid marketplace" alt="" />
                    </a>
                  )}
                  {this.state.product.link_tokopedia === null ? (
                    ""
                  ) : (
                    <a href={this.state.product.link_tokopedia}>
                      <img src={order2} className="img-fluid marketplace" alt="" />
                    </a>
                  )}
                  {this.state.product.link_shopee === null ? (
                    ""
                  ) : (
                    <a href={this.state.product.link_shopee}>
                      <img src={order3} className="img-fluid marketplace" alt="" />
                    </a>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-11 card mx-auto" style={{ marginTop: 10 + "px" }}>
              <h3 className="title">Description</h3>
              <pre className="text-left mx-auto" style={{ width: 90 + "%" }}>
                {this.state.product.description}
              </pre>
            </div>
            <div className="col-lg-12 col-md-12 col-11 card mx-auto" style={{ marginTop: 10 + "px" }}>
              <h3 className="title">All Product</h3>
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={responsive}
                ssr={true}
                infinite={true}
                autoPlay={this.props.deviceType !== "mobile" ? true : false}
                autoPlaySpeed={10000}
                keyBoardControl={true}
                customTransition="ease-in-out .5"
                transitionDuration={500}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={this.props.deviceType}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
              >
                {this.state.products.map((products, index) => (
                  <div key={products.id}>
                    <img
                      src={productImages[products.id]}
                      className="img-fluid image hoverable"
                      alt=""
                      onClick={(e) => this.onClick(e, products)}
                    />
                    <h5 className="hoverable" alt="" onClick={(e) => this.onClick(e, products)}>
                      {products.title}
                    </h5>
                    <p className="text-center">{products.price}</p>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
          <Link to={"/"} className="btn btn-success" style={{ marginTop: 15 + "px" }}>
            Back to Home
          </Link>
        </div>
        <Lines customLoading={!this.state.product.title && this.state.products.length === 0} />
      </>
    );
  }
}
